// extracted by mini-css-extract-plugin
export var header = "Header-module--header--4a049";
export var headerTransparent = "Header-module--header--transparent--2f52d";